module.exports = __webpack_public_path__ + "cd69c1e586e124162e0d145f96314dc2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/googley-19.png
// module id = 2035
// module chunks = 0